var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{staticClass:"custom-tabs mt-3",attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"active":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('b-icon-person-fill',{staticClass:"mr-2"}),_vm._v(" "+_vm._s(_vm.$t("reusable.userCard.profileTab"))+" ")]},proxy:true}])},[(_vm.user.is_student)?[_c('StudentCard',{attrs:{"User":_vm.user}})]:[_c('UserCard',{attrs:{"User":_vm.user}})]],2),(
        _vm.user &&
        ([
          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
          'DIRECTIVOS FACULTAD O ESCUELA',
          'DIRECTORES DE CARRERA',
          'DIRECTORES DE CARRERA (CAMPUS)',
          'ADMINISTRATIVOS INSTRUCCIONALES',
        ].some((group) => _vm.user.group_names.includes(group)) ||
          _vm.user.is_superuser)
      )?_c('b-tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('b-icon-clock-history',{staticClass:"mr-2"}),_vm._v(" "+_vm._s(_vm.$t("reusable.userCard.activityTab"))+" ")]},proxy:true}],null,false,4289596412)},[_c('UserLogsView')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }